import styled from "styled-components";

export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  h1 {
    margin-top: 10px;
    font-size: 24px;
    color: #28415B;
  }

  span {
    margin-top: 5px;
    font-size: 16px;
    color: #6E8398;
  }
`
